<template>
  <div>
    <div v-if="firstDay" class="d-none d-md-flex row my-1">
      <div class="col-md offset-md-3 text-left font-weight-bold">
        Activities
      </div>
      <div class="col-md-4 text-right font-weight-bold">Accommodation</div>
    </div>
    <div class="d-none d-md-flex row my-1 py-2 border-top">
      <div class="col-md-3">
        <p class="mb-0">
          <strong>Day {{ day.number }}</strong>
        </p>
        <p>{{ day.date }}</p>
      </div>
      <div class="col-md">
        <app-day-excursion
          :excursion="excursion"
          :dayNumber="day.number"
          :lastDay="lastDay"
          :readOnly="readOnly"
        >
        </app-day-excursion>
        <app-day-entertainment
          :excursion="entertainment"
          :time="day.entertainmentTime"
          :dayNumber="day.number"
          :lastDay="lastDay"
          :readOnly="readOnly"
        >
        </app-day-entertainment>
      </div>
      <div class="col-md-4 d-flex justify-content-end">
        <app-day-hotel
          :hotel="hotel"
          :dayNumber="day.number"
          :readOnly="readOnly"
        ></app-day-hotel>
      </div>
    </div>
    <div class="row d-md-none">
      <div class="col-12 mx-2 my-2">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-4">Day {{ day.number }}</div>
              <div class="col d-flex flex-row-reverse">{{ day.date }}</div>
            </div>
          </div>
          <div class="card-body">
            <app-day-excursion
              :excursion="excursion"
              :dayNumber="day.number"
              :lastDay="lastDay"
              :readOnly="readOnly"
            >
            </app-day-excursion>
            <app-day-entertainment
              :excursion="entertainment"
              :time="day.entertainmentTime"
              :dayNumber="day.number"
              :lastDay="lastDay"
              :readOnly="readOnly"
            >
            </app-day-entertainment>
          </div>
          <div v-if="!lastDay" class="card-footer">
            <app-day-hotel
              :hotel="hotel"
              :dayNumber="day.number"
              :readOnly="readOnly"
            ></app-day-hotel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import appDayExcursion from './DayExcursion.vue'
import appDayEntertainment from './DayEntertainment.vue'
import appDayHotel from './DayHotel.vue'

export default {
  props: {
    day: { type: Object, required: true },
    prevDay: { type: Object, default: null },
    nextDay: { type: Object, default: null },
    readOnly: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters([
      'getCountyHotels',
      'getCountyExcursions',
      'getCountyEntertainments'
    ]),
    excursion() {
      if (this.day.excursionId === 0) {
        return null
      }
      return this.getCountyExcursions.find(excr => {
        return excr.productId === this.day.excursionId
      })
    },
    entertainment() {
      if (this.day.entertainmentId === 0) {
        return null
      }
      return this.getCountyEntertainments.find(ent => {
        return ent.productId === this.day.entertainmentId
      })
    },
    hotel() {
      if (this.day.hotelId === 0) {
        return null
      }
      return this.getCountyHotels.find(htl => {
        return htl.productId === this.day.hotelId
      })
    },
    firstDay() {
      return this.day.number === 1
    },
    lastDay() {
      return this.nextDay === null
    },
    intermediateDay() {
      return !this.firstDay && !this.lastDay
    }
  },
  components: {
    appDayExcursion,
    appDayHotel,
    appDayEntertainment
  }
}
</script>
